const chest_displacement_chart_options = ({
    data
    // , categories
}) => ({
    title: {
        text: "",
        align: "left"
    },
    subtitle: {
        text: "",
        align: "left"
    },
    chart: {
        zoomType: "x",
        // type: "line",
        panKey: "alt",
        panning: true,
        borderRadius: 8,
    },
    xAxis: {
        type: "datetime",
        // tickInterval: 3600 * 1000,
        ordinal: false,
        gridLineColor: '#D2D8E5',
        lineColor: '#D2D8E5',
        scrollbar: {
            enabled: false
        },
        labels: {
            style: {
                fontFamily: 'Nunito',
                color: '#8F8F8F',
                fontSize: '10px'
            }
        }
    },
    yAxis: {
        // tickAmount: 3,
        gridLineColor: '#D2D8E5',
        lineColor: '#D2D8E5',
        labels: {
            style: {
                fontFamily: 'Nunito',
                color: '#8F8F8F',
                fontSize: '10px'
            }
        }
    },
    series: [{
        color: '#0E95FC',
        data,
        gapSize: 2
    }],
    labels: {
        overflow: "scroll"
    },
    navigator: {
        enabled: false
    },
    scrollbar: {
        enabled: false
    },
    plotOptions: {
        series: {
            pointPadding: 0,
            groupPadding: 0,
            gapSize: 0,
            name: ""
        }
    },
    exporting: {
        enabled: true
    },
    line: {
        marker: {
            enabled: false
        }
    }
});

export default chest_displacement_chart_options;